import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "passwordReminder.title",
    },
    email: {
        id: "account.email",
    },
    submit: {
        id: "general.send",
    },
    recoverySent: {
        id: "passwordReminder.recoverySent",
    },
    checkEmail: {
        id: "passwordReminder.checkEmail",
    },
    success: {
        id: "passwordReminder.success",
    },
    login: {
        id: "login.title",
    },
    titleSet: {
        id: "passwordReminder.titleSet",
    },
    password: {
        id: "account.password",
    },
    passwordAgain: {
        id: "account.passwordAgain",
    },
});

export default messages;
